// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1QcIh","title":"Images45_title__2Mu6N","images":"Images45_images__2YqIM"};